const PHONE_PROMPT_SNOOZE_SECONDS = 30 * 24 * 60 * 60;

export function isPhoneVerified(phoneVerified) {
  return phoneVerified === true || phoneVerified === 'true';
}

/**
 * Whether the post-login phone capture modal should be shown.
 * @param {{ phoneVerified?: boolean|string, phonePromptSkippedAt?: number|null, authorized?: boolean, accessToken?: string }} authUser
 */
export function shouldShowPhonePrompt(authUser) {
  if (!authUser || !(authUser.authorized || authUser.accessToken)) {
    return false;
  }

  if (isPhoneVerified(authUser.phoneVerified)) {
    return false;
  }

  const skippedAt = authUser.phonePromptSkippedAt;
  if (skippedAt == null || skippedAt === '') {
    return true;
  }

  const skippedUnix = Number(skippedAt);
  if (Number.isNaN(skippedUnix)) {
    return true;
  }

  const nowUnix = Math.floor(Date.now() / 1000);
  return nowUnix - skippedUnix >= PHONE_PROMPT_SNOOZE_SECONDS;
}
